import {DialogBody, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledMarkAsTrasmittedDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
    `
)

export const StyledMarkAsTrasmittedDialogFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        display: flex;
        justify-content: flex-end;
        gap: ${spacing * 2}px;
    `
)
